import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function onlyLettersValidator(): ValidatorFn {
  const regex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/; // letras + espacios + acentos
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || value === '') return null; // deja que "required" se encargue
    return regex.test(String(value)) ? null : { onlyLetters: true };
  };
}
